import React from 'react';
import { t } from 'i18next';
import { Modal } from '@brighterion/br-ui';
import type { ScheduledDeploymentContentProps } from '../ScheduledDeploymentContent';

import styles from './NoChanges.css';

export const NoChanges: React.FC<ScheduledDeploymentContentProps> = ({
    children,
    closeModal,
    modal,
    status,
    ...props
}) => {
    const { id, name, title } = modal;
    return (
        <>
            <Modal.Title id={name ?? id} onClose={closeModal} statusIcon={status} title={title} />
            <div className={styles.container} {...props}>
                {t('There are no changes to deploy')}
            </div>
            <Modal.Footer id={name ?? id} onClose={closeModal} />
        </>
    );
};
